import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, ArrowRight } from 'lucide-react';

export default function LeadConfirmation({ onReset }) {
  return (
    <div className="flex flex-col items-center justify-center flex-1 px-6 text-center">
      <motion.div
        initial={{ scale: 0, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ type: 'spring', damping: 12, stiffness: 180, delay: 0.08 }}
        className="relative mb-6"
      >
        <div className="w-20 h-20 rounded-full bg-gradient-to-br from-green-500/20 to-emerald-400/20 border border-green-500/25 flex items-center justify-center">
          <CheckCircle2 className="w-9 h-9 text-green-400" />
        </div>
        <motion.div
          className="absolute inset-0 rounded-full border border-green-400/30"
          animate={{ scale: [1, 1.4, 1.4], opacity: [0.5, 0, 0] }}
          transition={{ duration: 2, repeat: Infinity, ease: 'easeOut' }}
        />
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.22 }}
      >
        <h3 className="text-base font-semibold text-white mb-2">You're all set!</h3>
        <p className="text-xs text-gray-400 mb-7 leading-relaxed max-w-[240px]">
          Our team has received your details and will be in touch within one business day.
        </p>
        <button
          onClick={onReset}
          className="flex items-center gap-1.5 mx-auto text-sm text-blue-400 hover:text-cyan-400 transition-colors group"
        >
          Start a new conversation
          <ArrowRight className="w-3.5 h-3.5 group-hover:translate-x-0.5 transition-transform" />
        </button>
      </motion.div>
    </div>
  );
}
